import React, { useState, useContext } from "react";
import { Form, Button, Container, Row, Col, Card, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../components/AuthContext";
import { BASE_URL } from "../../config/baseUrl";
import "./LoginPage.css";

function LoginPage() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("danger");
  const [isRegister, setIsRegister] = useState(false);

  const [signinData, setSigninData] = useState({ Email: "", Password: "" });
  const [signupData, setSignupData] = useState({ FullName: "", Email: "", Password: "", MobileNo: "" });

  // ------------ Login Handler ------------
 // ------------ Login Handler ------------
const handleLoginSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post(`${BASE_URL}/AuthUser/login`, {
       email: signinData.Email,
       password: signinData.Password,
     });


    const { token, user } = res.data;

    login(user, token);
    navigate("/");
  } catch (error) {
    setAlertMessage("Login failed. Check credentials or server.");
    setAlertType("danger");
  }
};


  // ------------ Register Handler ------------
  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BASE_URL}/AuthUser/signup`, {
        fullName: signupData.FullName,
        email: signupData.Email,
        password: signupData.Password,
        mobileNo: signupData.MobileNo,
      });

      setAlertMessage(`Registration successful for ${signupData.FullName}`);
      setAlertType("success");
      setIsRegister(false);

      // Auto-login after signup
      const res = await axios.post(`${BASE_URL}/AuthUser/login`, {
        email: signupData.Email,
        password: signupData.Password,
      });

      const { token, user } = res.data;
      login(user, token);

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      navigate("/");
    } catch (error) {
      console.error(error);

      let msg = "Registration failed!";
      if (error.response) {
        msg = error.response.data?.message || error.response.data?.error || msg;
      } else if (error.request) {
        msg = "No response from server. Please try again later.";
      } else {
        msg = error.message;
      }

      setAlertMessage(msg);
      setAlertType("danger");
    }
  };

  // ------------ Switch Form ------------
  const switchForm = (register) => {
    setIsRegister(register);
    setAlertMessage("");
  };

  return (
    <div className="login-container">
      <Container fluid>
        <Row className="justify-content-center align-items-center h-100">
          <Col md={4} className="text-center d-none d-md-block">
            <img src="assets/img/logo.jpeg" className="img-fluid" alt="Logo" />
          </Col>
          <Col md={6} lg={5} xl={4}>
            <Card className="p-4 shadow-sm">
              {alertMessage && (
                <Alert variant={alertType} dismissible onClose={() => setAlertMessage("")}>
                  {alertMessage}
                </Alert>
              )}

              {!isRegister ? (
                <>
                  <h3 className="text-center mb-4">Sign in</h3>
                  <Form onSubmit={handleLoginSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={signinData.Email}
                        onChange={(e) => setSigninData({ ...signinData, Email: e.target.value })}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Enter password"
                        value={signinData.Password}
                        onChange={(e) => setSigninData({ ...signinData, Password: e.target.value })}
                        required
                      />
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span>Don’t have an account? </span>
                      <Button variant="link" className="register-link p-0" onClick={() => switchForm(true)}>
                        Register
                      </Button>
                    </div>
                    <Button type="submit" className="w-100 btn-login">
                      Login
                    </Button>
                  </Form>
                </>
              ) : (
                <>
                  <h3 className="text-center mb-4">Register</h3>
                  <Form onSubmit={handleRegisterSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your name"
                        value={signupData.FullName}
                        onChange={(e) => setSignupData({ ...signupData, FullName: e.target.value })}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={signupData.Email}
                        onChange={(e) => setSignupData({ ...signupData, Email: e.target.value })}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Mobile No.</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your mobile number"
                        value={signupData.MobileNo}
                        onChange={(e) => setSignupData({ ...signupData, MobileNo: e.target.value })}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Enter password"
                        value={signupData.Password}
                        onChange={(e) => setSignupData({ ...signupData, Password: e.target.value })}
                        required
                      />
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span>Already have an account? </span>
                      <Button variant="link" className="register-link p-0" onClick={() => switchForm(false)}>
                        Login
                      </Button>
                    </div>
                    <Button type="submit" className="w-100 btn-login">
                      Register
                    </Button>
                  </Form>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
      <foot>© Copyright ABCD International Family All Rights Reserved</foot>
    </div>
  );
}

export default LoginPage;
